import { useEffect } from 'react';
import { useChat } from './ChatProvider';
import { ChatButton } from './ChatButton';
import { ChatPanel } from './ChatPanel';

interface ChatWidgetProps {
  className?: string;
}

/**
 * Complete chat widget with button and panel
 * Must be wrapped in ChatProvider
 */
export function ChatWidget({ className }: ChatWidgetProps) {
  const { toggle, isOpen } = useChat();

  // Keyboard shortcut handler (Cmd+K / Ctrl+K)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Cmd+K or Ctrl+K to toggle chat
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        toggle();
      }
      // Escape to close chat
      if (e.key === 'Escape' && isOpen) {
        toggle();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle, isOpen]);

  return (
    <>
      <ChatButton className={className} />
      <ChatPanel />
    </>
  );
}

export default ChatWidget;

